import { digitFormater } from './functions';

export const formatEstimatedValue = (player) => {
  const minimum = Number(player?.potential_min);
  const maximum = Number(player?.potential_max);

  if (
    !Number.isFinite(minimum) ||
    !Number.isFinite(maximum) ||
    minimum < 0 ||
    maximum < 0
  ) {
    return 'N/A';
  }

  return `$${digitFormater(minimum)}-${digitFormater(maximum)}`;
};
